import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";

const AFFINITY_ENDPOINT: keyof paths = '/api/Item/GetAffinity';

export type ProfileAffinityRequest = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemAffinityRequest"];
export type ProfileAffinityResponseItem = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemExperienceAffinityByMetric"];
export type ProfileAffinityResponse = ProfileAffinityResponseItem[];

export function useProfileAffinity(
    payload: ProfileAffinityRequest,
): {
    isLoading: boolean;
    data: ProfileAffinityResponse;
} {
    const response = useAxios<ProfileAffinityResponse, ProfileAffinityRequest>({
        url: AFFINITY_ENDPOINT,
        method: 'post',
        payload,
    });

    return {
        ...response,
        data: response.data ?? [],
    };
}